import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-c01 c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "c-common-inner p-the-page-c01__inner" }
const _hoisted_5 = { class: "p-the-page-c01__body" }
const _hoisted_6 = { class: "p-the-page-c01__section" }
const _hoisted_7 = { class: "p-the-page-c01__flex" }
const _hoisted_8 = { class: "p-the-page-c01__flex__left" }
const _hoisted_9 = { class: "p-the-page-c01__flex__left__thumbnails" }
const _hoisted_10 = { class: "p-the-page-c01__flex__right" }
const _hoisted_11 = { class: "p-the-page-c01__section" }
const _hoisted_12 = { class: "p-the-page-c01__section__histories" }
const _hoisted_13 = { class: "p-the-page-c01__section__histories__button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_TheC01ItemThumbnailsSp = _resolveComponent("TheC01ItemThumbnailsSp")!
  const _component_TheC01ItemThumbnailsPc = _resolveComponent("TheC01ItemThumbnailsPc")!
  const _component_TheC01ItemInfo = _resolveComponent("TheC01ItemInfo")!
  const _component_TheC01ItemForm = _resolveComponent("TheC01ItemForm")!
  const _component_TheC01ItemDetail = _resolveComponent("TheC01ItemDetail")!
  const _component_ItemCarousel = _resolveComponent("ItemCarousel")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheBreadcrumb)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_TheC01ItemThumbnailsSp, {
                    class: "p-the-page-c01__flex__left__thumbnails__sp",
                    thumbnails: _ctx.item.premiumimage_set
                  }, null, 8, ["thumbnails"]),
                  _createVNode(_component_TheC01ItemThumbnailsPc, {
                    class: "p-the-page-c01__flex__left__thumbnails__pc",
                    thumbnails: _ctx.item.premiumimage_set
                  }, null, 8, ["thumbnails"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_TheC01ItemInfo, {
                  id: _ctx.menuNo,
                  name: _ctx.item.name,
                  point: _ctx.point,
                  stock: _ctx.stock,
                  "discount-rate": _ctx.item.discount_rate,
                  status: _ctx.status,
                  "is-quantity-control": _ctx.isQuantityControl,
                  "is-benepo-exchange": _ctx.isBenepoExchange
                }, null, 8, ["id", "name", "point", "stock", "discount-rate", "status", "is-quantity-control", "is-benepo-exchange"]),
                _createVNode(_component_TheC01ItemForm, {
                  id: _ctx.id,
                  "is-favorite": _ctx.isFavorite,
                  "onUpdate:isFavorite": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isFavorite) = $event)),
                  point: _ctx.point,
                  "onUpdate:point": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.point) = $event)),
                  stock: _ctx.stock,
                  "onUpdate:stock": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stock) = $event)),
                  "is-quantity-control": _ctx.isQuantityControl,
                  "onUpdate:isQuantityControl": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isQuantityControl) = $event)),
                  jan_code: _ctx.jan_code,
                  "onUpdate:jan_code": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.jan_code) = $event)),
                  "extra-prop": _ctx.extraProp,
                  "onUpdate:extraProp": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.extraProp) = $event)),
                  "age-alert": _ctx.is_age_alert,
                  "onUpdate:ageAlert": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.is_age_alert) = $event)),
                  type: _ctx.type,
                  "option-types": _ctx.item.option_types,
                  options: _ctx.skuSet,
                  "cart-item": _ctx.cartItem,
                  possession: _ctx.userRedeemablePoints,
                  "credit-card-enabled": _ctx.creditCardEnabled,
                  "sale-end-date": _ctx.item.sale_end_date,
                  "client-list": _ctx.clientList,
                  "is-benepo-exchange": _ctx.isBenepoExchange,
                  "is-hidden-item": _ctx.isHiddenItem,
                  onFavorite: _cache[7] || (_cache[7] = ($event: any) => (_ctx.favorite($event))),
                  onUnfavorite: _cache[8] || (_cache[8] = ($event: any) => (_ctx.unfavorite($event)))
                }, null, 8, ["id", "is-favorite", "point", "stock", "is-quantity-control", "jan_code", "extra-prop", "age-alert", "type", "option-types", "options", "cart-item", "possession", "credit-card-enabled", "sale-end-date", "client-list", "is-benepo-exchange", "is-hidden-item"])
              ])
            ])
          ]),
          _createVNode(_component_TheC01ItemDetail, {
            "comment-index": _ctx.item.catch,
            "comment-detail-main": _ctx.item.text,
            "comment-detail-sub": _ctx.item.content,
            "comment-detail-sub-second": _ctx.item.note,
            "jan-code": _ctx.jan_code,
            "sale-start-date": _ctx.item.sale_start_date,
            "sale-end-date": _ctx.item.sale_end_date,
            category: _ctx.category.main,
            "category-child": _ctx.category.child
          }, null, 8, ["comment-index", "comment-detail-main", "comment-detail-sub", "comment-detail-sub-second", "jan-code", "sale-start-date", "sale-end-date", "category", "category-child"]),
          _createElementVNode("div", _hoisted_11, [
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "p-the-page-c01__section__title" }, "閲覧履歴", -1)),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.showHistories)
                ? (_openBlock(), _createBlock(_component_ItemCarousel, {
                    key: 0,
                    "item-list": _ctx.histories,
                    "carousel-name": "histories"
                  }, null, 8, ["item-list"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.showHistories)
                  ? (_openBlock(), _createBlock(_component_ButtonMain, {
                      key: 0,
                      tag: "a",
                      href: "/browser-history/",
                      kind: "secondary"
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("もっと見る", -1)
                      ])),
                      _: 1,
                      __: [9]
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}